import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  selected: boolean
  placeholder: string
  selectedTitle: string
  selectedCount: number
}

export const BaseEntitySelectorWrapper = ({
  selected,
  placeholder,
  selectedTitle,
  selectedCount,
}: Props) => {
  const borderColor = selected ? 'viridian1000' : 'grey400'
  const backgroundColor = selected ? 'viridian100' : 'white'
  const iconColor = selected ? 'viridian1200' : 'grey600'

  return (
    <Box
      gap="s4"
      paddingY="s4"
      paddingRight="s8"
      paddingLeft="s12"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      background={backgroundColor}
      borderRadius={{ all: 'abs008' }}
      border={{ all: { color: borderColor, width: 's2', style: 'solid' } }}
    >
      {selected ? (
        <>
          <Text.Normal capitalize size="200" weight="semibold" color="viridian1200">
            {`${selectedTitle}: `}
          </Text.Normal>
          <Text.Normal capitalize size="200" color="viridian1200">
            {`(${selectedCount})`}
          </Text.Normal>
        </>
      ) : (
        <Text.Normal capitalize size="200" color="grey800">
          {placeholder}
        </Text.Normal>
      )}
      <Icon.Small icon="chevron-down" color={iconColor} />
    </Box>
  )
}
